<template>
  <div>
    <a :href="'/survey/form-survey'">
      <div id="ICON">
        <img :src="'/assets/img/2066458_Artboard_1.png'" alt="類血友病凝血功能異常評估表"/>
        <p>填寫評估表</p>
      </div>
    </a>
    <a :href="'/survey/form-survey'">
      <div id="ICON-1">
        <img :src="'/assets/img/2066458-02.png'" alt="類血友病凝血功能異常評估表" />
        <p>填寫評估表</p>
      </div>
    </a>

    <div class="bgc">
      <div class="header">
        <div class="container">
          <div class="middle animate__animated animate__pulse">
            <h1 class="mt">
              <span class="title-custom">凝血功能異常評估表</span>
              <h2 class="mt-1 sub-title-custom">
                此網站提供有凝血異常相關症狀之民眾，在家自我填答檢測疾病風險<br />並進一步尋求專業醫師協助。
              </h2>
            </h1>
          </div>
        </div>
      </div>
    </div>

    <div class="container-fluid background">
      <div class="container">
        <div class="col-12">
          <div class="big">
            <div class="">
              <div class="text vanwee a">
                <div class="col-12 col-md-12 mx-auto pt-5">
                  <h1>凝血功能異常相關疾病</h1>
                </div>

                <p>
                  最為人所知的凝血功能異常疾病為血友病，其成因是血液中缺乏第八、第九凝血因子。
                </p>
                <p>
                  然而盛行率最高的遺傳性出血疾病其實是<span
                    style="font-weight: bolder"
                    >“類血友病(von Willebrand Disease, VWD)”</span
                  >因患者體內類血友病因子(von Willebrand Factor,
                  VWF)不足或功能缺乏導致凝血異常。
                </p>
                <p>
                  血友病主要為性聯遺傳，故多數病友皆為男性，而類血友病則是非性聯遺傳，所以患者男女比例相近，在女性中為最常見的止血異常疾病。
                </p>

                <p>
                  若填寫完凝血功能異常評估表後，您的凝血功能分數為異常，則有患病風險，請盡速前往醫院諮詢血液科醫師。
                </p>
              </div>

              <div class="text vanwee a">
                <div class="img">
                  <a :href="'/survey/form-survey'"> 填寫『評估表』 </a>
                </div>
              </div>
            </div>

            <div class="e">
              <div class="col-12 col-md-6 mx-auto pt-5">
                <h1>類血友病症狀</h1>
              </div>
              <div class="icon-img vanwee">
                <div class="icon-box">
                  <a
                    href="#"
                    class="btn btn-lg btn-success"
                    data-toggle="modal"
                    data-target="#basicModal-1"
                    ><img
                      class="icon icon-1"
                      id="icon-1"
                      :src="'/assets/img/icon-02.png'"
                      alt="類血友病凝血功能異常評估表"
                  /></a>
                  <div class="card-1" id="card-1">
                    <div class="box-big">
                      <img :src="'/assets/img/iconn-02.png'" alt="類血友病凝血功能異常評估表" />

                      <p>拔牙後出血：牙科術後，傷口持續流血超過3小時。</p>
                    </div>
                  </div>
                  <a
                    href="#"
                    class="btn btn-lg btn-success"
                    data-toggle="modal"
                    data-target="#basicModal-2"
                    ><img
                      class="icon icon-2"
                      id="icon-2"
                      :src="'/assets/img/icon-03.png'"
                      alt="類血友病凝血功能異常評估表"
                  /></a>
                  <div class="card-2" id="card-2">
                    <div class="box-big-1">
                      <img :src="'/assets/img/iconn-06.png'" alt="類血友病凝血功能異常評估表" />

                      <p>流鼻血：鼻血持續流超過10分鐘，頻率約為每年5次以上。</p>
                    </div>
                  </div>
                </div>

                <div class="icon-box">
                  <a
                    href="#"
                    class="btn btn-lg btn-success"
                    data-toggle="modal"
                    data-target="#basicModal-3"
                    ><img
                      class="icon icon-3"
                      id="icon-3"
                      :src="'/assets/img/icon-04.png'"
                      alt="類血友病凝血功能異常評估表"
                  /></a>
                  <div class="card-3" id="card-3">
                    <div class="box-big">
                      <img :src="'/assets/img/iconn-03.png'" alt="" />

                      <p>牙齦出血：日常清潔口腔 (刷牙、使用牙線後)流血不止。</p>
                    </div>
                  </div>
                  <a
                    href="#"
                    class="btn btn-lg btn-success"
                    data-toggle="modal"
                    data-target="#basicModal-4"
                    ><img
                      class="icon icon-4"
                      id="icon-4"
                      :src="'/assets/img/icon-05.png'"
                      alt="類血友病凝血功能異常評估表"
                  /></a>
                  <div class="card-4" id="card-4">
                    <div class="box-big-1">
                      <img :src="'/assets/img/iconn-07.png'" alt="類血友病凝血功能異常評估表" />

                      <p>
                        腸胃道出血：曾患有過胃潰瘍、痔瘡、高血壓或不明原因的自發性腸胃出血。
                      </p>
                    </div>
                  </div>
                </div>

                <div class="icon-box">
                  <a
                    href="#"
                    class="btn btn-lg btn-success"
                    data-toggle="modal"
                    data-target="#basicModal-5"
                    ><img
                      class="icon icon-5"
                      id="icon-5"
                      :src="'/assets/img/icon-06.png'"
                      alt="類血友病凝血功能異常評估表"
                  /></a>
                  <div class="card-5" id="card-5">
                    <div class="box-big">
                      <img :src="'/assets/img/iconn-04.png'" alt="類血友病凝血功能異常評估表" />

                      <p>
                        瘀青：手臂和雙腿皮膚常出現凸起的小腫塊，或是直徑大於2公分的瘀傷，頻率約為每個月1-4次。
                      </p>
                    </div>
                  </div>
                  <a
                    href="#"
                    class="btn btn-lg btn-success"
                    data-toggle="modal"
                    data-target="#basicModal-6"
                    ><img
                      class="icon icon-6"
                      id="icon-6"
                      :src="'/assets/img/icon-07.png'"
                      alt="類血友病凝血功能異常評估表"
                  /></a>
                  <div class="card-6" id="card-6">
                    <div class="box-big-1">
                      <img :src="'/assets/img/iconn-09.png'" alt="" />

                      <p>
                        月經過多：月經時間超過1週、每2小時內需更換衛生棉、排出血塊直徑超過3公分。
                      </p>
                    </div>
                  </div>
                </div>

                <div class="icon-box">
                  <a
                    href="#"
                    class="btn btn-lg btn-success"
                    data-toggle="modal"
                    data-target="#basicModal-7"
                    ><img
                      class="icon icon-7"
                      id="icon-7"
                      :src="'/assets/img/icon-08.png'"
                      alt="類血友病凝血功能異常評估表"
                  /></a>
                  <div class="card-7" id="card-7">
                    <div class="box-big">
                      <img :src="'/assets/img/iconn-05.png'" alt="類血友病凝血功能異常評估表" />

                      <p>小外傷造成出血：傷口持續流血超過5分鐘。</p>
                    </div>
                  </div>
                  <a
                    href="#"
                    class="btn btn-lg btn-success"
                    data-toggle="modal"
                    data-target="#basicModal-8"
                    ><img
                      class="icon icon-8"
                      id="icon-8"
                      :src="'/assets/img/icon-09.png'"
                      alt="類血友病凝血功能異常評估表"
                  /></a>
                  <div class="card-8" id="card-8">
                    <div class="box-big-1">
                      <img :src="'/assets/img/iconn-08.png'" alt="類血友病凝血功能異常評估表" />

                      <p>
                        關節內出血：手肘、膝蓋及腳踝等關節處反覆發炎，甚至感到壓迫性的腫脹與不明原因的自發性出血。
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="s">
              <div class="img-1">
                <a :href="'/survey/form-survey'"> 填寫『自評表』 </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- basic modal -->
    <div
      class="modal fade"
      id="basicModal-1"
      tabindex="-1"
      role="dialog"
      aria-labelledby="basicModal-1"
      aria-hidden="true"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="box-big">
              <img :src="'/assets/img/iconn-02.png'" alt="" />

              <p>拔牙後出血：牙科術後，傷口持續流血超過3小時。</p>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-default color"
              data-dismiss="modal"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- --------------------------------------------- -->

    <div
      class="modal fade"
      id="basicModal-2"
      tabindex="-1"
      role="dialog"
      aria-labelledby="basicModal-2"
      aria-hidden="true"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="box-big-1">
              <img :src="'/assets/img/iconn-06.png'" alt="" />

              <p>流鼻血：鼻血持續流超過10分鐘，頻率約為每年5次以上。</p>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-default color"
              data-dismiss="modal"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- ----------------------------------------------------------------   -->
    <div
      class="modal fade"
      id="basicModal-3"
      tabindex="-1"
      role="dialog"
      aria-labelledby="basicModal-3"
      aria-hidden="true"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="box-big">
            <img :src="'/assets/img/iconn-03.png'" alt="" />

            <p>牙齦出血：日常清潔口腔 (刷牙、使用牙線後)流血不止。</p>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-default color"
              data-dismiss="modal"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- --------------------------------------------- -->

    <div
      class="modal fade"
      id="basicModal-4"
      tabindex="-1"
      role="dialog"
      aria-labelledby="basicModal-4"
      aria-hidden="true"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="box-big-1">
              <img :src="'/assets/img/iconn-07.png'" alt="" />

              <p>
                腸胃道出血：曾患有過胃潰瘍、痔瘡、高血壓或不明原因的自發性腸胃出血。
              </p>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-default color"
              data-dismiss="modal"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- ----------------------------------------------------------------   -->
    <div
      class="modal fade"
      id="basicModal-5"
      tabindex="-1"
      role="dialog"
      aria-labelledby="basicModal-5"
      aria-hidden="true"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="box-big">
              <img :src="'/assets/img/iconn-04.png'" alt="" />

              <p>
                瘀青：手臂和雙腿皮膚常出現凸起的小腫塊，或是直徑大於2公分的瘀傷，頻率約為每個月1-4次。
              </p>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-default color"
              data-dismiss="modal"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- --------------------------------------------- -->

    <div
      class="modal fade"
      id="basicModal-6"
      tabindex="-1"
      role="dialog"
      aria-labelledby="basicModal-6"
      aria-hidden="true"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="box-big-1">
              <img :src="'/assets/img/iconn-09.png'" alt="" />

              <p>
                月經過多：月經時間超過1週、每2小時內需更換衛生棉、排出血塊直徑超過3公分。
              </p>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-default color"
              data-dismiss="modal"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- ----------------------------------------------------------------   -->
    <div
      class="modal fade"
      id="basicModal-7"
      tabindex="-1"
      role="dialog"
      aria-labelledby="basicModal-7"
      aria-hidden="true"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="box-big">
              <img :src="'/assets/img/iconn-05.png'" alt="" />

              <p>小外傷造成出血：傷口持續流血超過5分鐘。</p>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-default color"
              data-dismiss="modal"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- --------------------------------------------- -->

    <div
      class="modal fade"
      id="basicModal-8"
      tabindex="-1"
      role="dialog"
      aria-labelledby="basicModal-8"
      aria-hidden="true"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="box-big-1">
              <img :src="'/assets/img/iconn-08.png'" alt="" />

              <p>
                關節內出血：手肘、膝蓋及腳踝等關節處反覆發炎，甚至感到壓迫性的腫脹與不明原因的自發性出血。
              </p>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-default color"
              data-dismiss="modal"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script src="https://cdnjs.cloudflare.com/ajax/libs/jquery/3.2.1/jquery.min.js "></script>
<script src="https://unpkg.com/popper.js"></script>
<script src="https://cdnjs.cloudflare.com/ajax/libs/twitter-bootstrap/4.0.0-beta/js/bootstrap.min.js"></script>

<script>
window.onload = () => {
  document.addEventListener(
    "touchstart",
    (event) => {
      if (event.touches.length > 1) {
        event.preventDefault();
      }
    },
    { passive: false }
  );

  let lastTouchEnd = 0;
  document.addEventListener(
    "touchend",
    (event) => {
      const now = new Date().getTime();
      if (now - lastTouchEnd <= 300) {
        event.preventDefault();
      }
      lastTouchEnd = now;
    },
    false
  );
};

var window_height = document.documentElement.clientHeight;

window.onresize = function () {
  window_height = document.documentElement.clientHeight;
};

var My_vanwee = document.getElementsByClassName(`vanwee`);

window.onscroll = function () {
  var _scrollTop =
    document.body.scrollTop || document.documentElement.scrollTop;

  for (var k = 0; k < My_vanwee.length; k++) {
    if (
      My_vanwee[k].classList.contains("f-up") == false &&
      _scrollTop >= getOffsetTop(My_vanwee[k]) - window_height &&
      _scrollTop <= getOffsetTop(My_vanwee[k])
    ) {
      My_vanwee[k].classList.add("f-up");
    }
  }
};

function getOffsetTop(ele) {
  var rtn = ele.offsetTop;
  var o = ele.offsetParent;
  while (o != null) {
    rtn += o.offsetTop;
    o = o.offsetParent;
  }
  return rtn;
}

function my_animation() {
  var _scrollTop =
    document.body.scrollTop || document.documentElement.scrollTop;

  for (var k = 0; k < My_vanwee.length; k++) {
    if (
      My_vanwee[k].classList.contains("f-up") == false &&
      _scrollTop >= getOffsetTop(My_vanwee[k]) - window_height &&
      _scrollTop <= getOffsetTop(My_vanwee[k])
    ) {
      My_vanwee[k].classList.add("f-up");
    }
  }
}
my_animation();

$(window).scroll(function () {
  var NOW = $(window).scrollTop();

  $("#ICON")
    .stop(true, false)
    .animate({ top: NOW + 200 }, 1500, "easeOutBack");
});

// var swiper = new Swiper(".swiper-container", {
//   pagination: {
//     el: ".swiper-pagination",
//     dynamicBullets: true,
//   },
//   autoplay: {
//     delay: 3500,
//     DisableOnInteraction: false,
//   },
// });
</script>

<style scoped>
.title-custom {
  font-size: 55px;
}

.sub-title-custom {
  font-size: 24px;
}

@media screen and (max-width: 470px) {
  .title-custom {
    font-size: 35px;
  }

  .sub-title-custom {
    font-size: 20px;
  }
}

@media screen and (min-width: 1700px) {
  .a h1 {
    width: 360px !important;
    margin: 0 auto;
  }
}
</style>
  
